import { render, staticRenderFns } from "./bInputWrapper.vue?vue&type=template&id=a5a78f78&scoped=true&"
import script from "./bInputWrapper.vue?vue&type=script&lang=js&"
export * from "./bInputWrapper.vue?vue&type=script&lang=js&"
import style0 from "./bInputWrapper.vue?vue&type=style&index=0&id=a5a78f78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a78f78",
  null
  
)

export default component.exports